import { GlobalRouter, Router } from '@okapi/router-react';
import React from 'react';
import { ThemeProvider } from 'fronton-react';
import { StoreContext } from 'storeon/react';
import { CssBaseline } from 'components/css-baseline';
import { Store } from 'store/types';
import { HeaderComponent } from 'components/header';
import { initLayers } from '../init-layers';

export type HeaderProps = {
  router: GlobalRouter;
  store: Store;
  disableAppsflyer?: boolean;
  disableSticky?: boolean;
  disableHorizontalMenu?: boolean;
  withoutRegionModalButton?: boolean;
  disableRegionsSeo?: boolean;
};

export const Header: React.FC<HeaderProps> = ({
  router,
  store,
  disableSticky,
  disableAppsflyer,
  disableHorizontalMenu,
  withoutRegionModalButton,
  disableRegionsSeo,
}) => {
  if (!__IS_SERVER__) {
    initLayers(store.get().cookies);
  }

  return (
    <Router router={router}>
      <CssBaseline>
        <ThemeProvider>
          <StoreContext.Provider value={store}>
            <HeaderComponent
              disableSticky={!!disableSticky}
              disableAppsflyer={disableAppsflyer}
              disableHorizontalMenu={disableHorizontalMenu}
              withoutRegionModalButton={withoutRegionModalButton}
              disableRegionsSeo={disableRegionsSeo}
            />
          </StoreContext.Provider>
        </ThemeProvider>
      </CssBaseline>
    </Router>
  );
};
